import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState } from 'editor/src/store/editorModules/preview/types';

const setFlatPreviewAvailableReducer = (state: PreviewState, action: PayloadAction<boolean>) => {
  state.flatPreviewAvailable = action.payload;
};

export default setFlatPreviewAvailableReducer;
